export default "__VITE_ASSET__72c19136__"